/* eslint-disable */
import styled from 'styled-components';

import React, { useEffect, useRef } from 'react';

import { emptyClipboard, isFirefoxBrowser } from '../../utils/utils';

export const PreventCopyPastInput = styled.input`
  width: 0.1px;
  height: 0.1px;
  overflow: hidden;
  display: none;
`;
/**
 * This component is used to prevent users from pasting any text that the user
 * might have copied from outside the test interface. It handles this by clearing
 * the clipboard when the window object gets focus.
 * FireFox had some restrictions which prevents writing to clipboard when focus
 * event is triggered. To handle this we add 2 listiners to track 'paste', and 'click'
 * events. It will prevent the first 'paste' and 'click' events after the 'focus'
 * event and removes the listiner.
 * The order at which the "clearClipboard()" is called is important, when firefox
 * prevents copy to clipboard command it also won't run any function that comes after
 * it
 */
export default function PreventCopyPast() {
  const preventCopyRef = useRef(null);

  useEffect(() => {
    const clearClipboard = () => {
      emptyClipboard(preventCopyRef.current);
    };
    clearClipboard();

    const preventPasteHandler = event => {
      event.preventDefault();
      clearClipboard();
      window.removeEventListener('paste', preventPasteHandler);
      window.removeEventListener('click', preventPasteHandler);
    };
    window.addEventListener('focus', () => {
      window.addEventListener('paste', preventPasteHandler);
      window.addEventListener('click', preventPasteHandler);
      /**
       * In some OS the middle button acts as a shortcut for paste, with
       * out the clipboard. so disable the event
       */
      if (!window.onauxclick)
        window.onauxclick = event => event.preventDefault();
      clearClipboard();
    });
    window.addEventListener('blur', () => {
      if (isFirefoxBrowser()) {
        setTimeout(() => {
          if (!document.hasFocus()) clearClipboard();
        }, 0);
      } else {
        if (!document.hasFocus()) clearClipboard();
      }
    });
  }, []);

  return (
    <>
      <PreventCopyPastInput ref={preventCopyRef} type="text" value="" />
    </>
  );
}
